module.exports = __webpack_public_path__ + "img/brave.86693447.svg";